var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.081,
    height: 28.165,
    viewBox: "0 0 22.081 28.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-text-outline",
    transform: "translate(-5.85 -2.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M27.031,14.356V26.7a3.042,3.042,0,0,1-3.042,3.042H9.792A3.042,3.042,0,0,1,6.75,26.7V6.417A3.042,3.042,0,0,1,9.792,3.375H16.05a2.028,2.028,0,0,1,1.433.594l8.952,8.952a2.028,2.028,0,0,1,.594,1.433Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M18,3.938v7.606a2.028,2.028,0,0,0,2.028,2.028h7.606",
    transform: "translate(-1.11 -0.056)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M12.375,20.25h10.14",
    transform: "translate(-0.555 -1.664)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M12.375,25.875h10.14",
    transform: "translate(-0.555 -2.219)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTextIcon);
export default __webpack_public_path__ + "static/media/document-text-icon.3264b01b5df5576fe02b52d2d7944d8b.svg";
export { ForwardRef as ReactComponent };